import React, { useEffect } from "react";
import downloadKV from "@images/download/download-kv.jpg";
import whitePanel from "@images/download/white-panel.png";
import { useIntl } from "gatsby-plugin-intl";
import { useMediaQuery } from "@react-hookz/web";
import DownloadButton from "@components/DownloadButton";
import ShareWidget from "@components/ShareWidget";

const pageContainerStyle = {
  width: "100%",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  position: "relative",
};

const contentBlockStyle = {
  backgroundImage: `url(${whitePanel})`,
  backgroundSize: "100% 100%",
  position: "absolute",
  bottom: "20px",
  width: "560px",
  height: "250px",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  padding: "50px 50px 30px 50px",
  color: "#1f2025",
  fontWeight: 400,
};

const DownloadPage = () => {
  const { formatMessage, locale } = useIntl();
  const isMobile = useMediaQuery("screen and (max-width: 1024px)");

  useEffect(() => {
    if (!isMobile) return;

    window.location.href =
      locale === "zh-Hans"
        ? process.env.REACT_APP_Taptap_URL
        : process.env.REACT_APP_APP_ADJUST_URL;
  }, [isMobile, locale]);

  return (
    <div style={pageContainerStyle}>
      <img
        src={downloadKV}
        alt="key-visual"
        style={{ objectFit: "cover", objectPosition: "center" }}
      />
      <div style={contentBlockStyle}>
        <DownloadButton />
        <div>{formatMessage({ id: "download-share" })}</div>
        <div css={{ marginTop: "15px" }}>
          <ShareWidget dark />
        </div>
      </div>
    </div>
  );
};

export default DownloadPage;
